module.exports = __webpack_public_path__ + "img/ProgramActive.dd4a3c56.png";